import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Switch } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import {
  useUpdateIDTFMutation,
  useGetReportBillingHistoryQuery,
} from "app/store/transmission/api/transmissionDetailApi";
import { changeProfileField } from "app/store/transmission/slice/transmissionSlice";
import {
  EVOKE_ROLES,
  EVOKE_ACTIVE,
  BENCHMARK_BILLING_CODES,
} from "static/constants";
import { showErrorToast, showSuccessToast } from "utils/toast";
import { getCurrentUserRole } from "utils/currentUser.util";

const IdtfToggle = ({ patientId }) => {
  const dispatch = useDispatch();
  const userRole = getCurrentUserRole();

  const {
    reportId,
    reportDetail,
    reportCurrentTab,
    information,
    billableDate,
    reportAccountDetail,
  } = useSelector((state) => state.transmission);

  const [updateIDTF] = useUpdateIDTFMutation();
  const { data: billingHistory } = useGetReportBillingHistoryQuery(reportId, {
    skip: !reportId || !EVOKE_ROLES.includes(userRole),
  });

  const settings = reportAccountDetail?.settings;
  const isFirstBilling =
    billingHistory?.length === 0 ||
    (billingHistory?.length === 1 &&
      billingHistory[0]?.report_id === reportDetail?._id);

  const showToggle =
    EVOKE_ROLES.includes(userRole) &&
    reportCurrentTab === EVOKE_ACTIVE &&
    settings?.export_for_billing &&
    settings?.billing_type === "SPLIT" &&
    BENCHMARK_BILLING_CODES.includes(reportDetail?.billing_code) &&
    isFirstBilling &&
    billableDate;

  if (!showToggle) return null;

  const setIdtf = (value) =>
    dispatch(
      changeProfileField({
        type: "information",
        value: { ...information, idtf: value },
      })
    );

  const handleToggle = async (value) => {
    try {
      const result = await updateIDTF({
        patientId,
        status: !information?.idtf,
      }).unwrap();

      if (result) {
        setIdtf(value);
        showSuccessToast(result?.message);
      }
    } catch (error) {
      setIdtf(!value);
      showErrorToast(error?.message);
    }
  };

  return (
    <div
      style={{
        fontSize: "12px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        paddingBottom: "8px",
        color: "#757575",
      }}
    >
      <InfoOutlinedIcon style={{ fontSize: "18px" }} />
      <p>Send this transmission report to Benchmark for billing charge</p>
      <Switch
        name="idtf"
        checked={information?.idtf ?? false}
        onChange={(event) => handleToggle(event.target.checked)}
        size="small"
      />
    </div>
  );
};

export default IdtfToggle;
